import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '@iconify/react';
import styles from './SubmitResource.module.css';
// import { useLanguage } from '../i18n';
import { useLanguage } from '../../i18n';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function SubmitResource() {
  const { t } = useLanguage();
  const [formData, setFormData] = useState({
    title: '',
    type: 'Guide',
    description: '',
    languages: '',
    files: null,
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Replace this with your actual third-party auth user ID retrieval
  // e.g. from Clerk: useUser().user.id
  //     from Firebase: auth.currentUser.uid
  //     from Auth0: user.sub
  const userId = 'user_3rdparty_clerk_abc123xyz'; // ← REPLACE THIS WITH REAL USER ID

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setFormData((prev) => ({ ...prev, files: e.target.files }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setLoading(true);

  const trimmedTitle = formData.title.trim();
  const trimmedDesc = formData.description.trim();

  if (!trimmedTitle) {
    setError('Resource title is required.');
    setLoading(false);
    return;
  }
  if (!trimmedDesc) {
    setError('Description is required.');
    setLoading(false);
    return;
  }

  try {
    const formPayload = new FormData();
    formPayload.append('title', trimmedTitle);
    formPayload.append('type', formData.type);
    formPayload.append('description', trimmedDesc);
    formPayload.append('languages', formData.languages.trim());



    if (formData.files && formData.files.length > 0) {
      Array.from(formData.files).forEach((file) => {
        formPayload.append('files', file);
      });
    }

    console.log('Submitting resource with payload:', formPayload, 'and userId:', userId);
    console.log("Submitting resource:");

for (const [key, value] of formPayload.entries()) {
  console.log(key, value);
}

console.log("userId:", userId);

    const res = await fetch(`${API_URL}/resources/submit`, {
      method: 'POST',
      headers: {
        'x-user-id': userId, // ← your auth user ID
      },
      body: formPayload,
    });

    if (!res.ok) {
      const errData = await res.json();
      throw new Error(errData.error || `Server error: ${res.status}`);
    }

    const data = await res.json();
    console.log('Submitted successfully:', data);

    setSubmitted(true);
  } catch (err) {
    console.error('Submit error:', err);
    setError(err.message || 'Failed to submit resource. Please try again.');
  } finally {
    setLoading(false);
  }
};

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError('');
  //   setLoading(true);

  //   // Basic client-side validation
  //   if (!formData.title.trim()) {
  //     setError('Resource title is required.');
  //     setLoading(false);
  //     return;
  //   }
  //   if (!formData.description.trim()) {
  //     setError('Description is required.');
  //     setLoading(false);
  //     return;
  //   }

  //   try {
  //     const formPayload = new FormData();
  //     formPayload.append('title', formData.title.trim());
  //     formPayload.append('type', formData.type);
  //     formPayload.append('description', formData.description.trim());
  //     formPayload.append('languages', formData.languages.trim());

  //     // Append files if any
  //     if (formData.files && formData.files.length > 0) {
  //       Array.from(formData.files).forEach((file) => {
  //         formPayload.append('files', file);
  //       });
  //     }

  //     const res = await fetch(`${API_URL}/resources/submit`, {
  //       method: 'POST',
  //       headers: {
  //         'x-user-id': userId, // ← your auth provider sends this
  //       },
  //       body: formPayload, // FormData handles multipart automatically
  //     });

  //     if (!res.ok) {
  //       const errData = await res.json();
  //       throw new Error(errData.error || `Server error: ${res.status}`);
  //     }

  //     const data = await res.json();
  //     console.log('Submitted successfully:', data);

  //     setSubmitted(true);
  //   } catch (err) {
  //     console.error('Submit error:', err);
  //     setError(err.message || 'Failed to submit resource. Please try again.');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  if (submitted) {
    return (
      <main className={styles.main}>
        <div className={styles.container}>
          <div className={styles.successCard}>
            <Icon icon="lucide:check-circle" className={styles.successIcon} />
            <h2>{t('submissionThanksTitle')}</h2>
            <p>{t('submissionThanksMessage')}</p>
            <div className={styles.successActions}>
              <Link to="/collections" className={styles.successBtn}>
                {t('browseCollections')}
              </Link>
              <Link to="/" className={styles.successBtnOutline}>
                {t('returnToHome')}
              </Link>
            </div>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className={styles.main}>
      <div className={styles.container}>
        {/* Header */}
        <header className={styles.header}>
          <div className={styles.headerTop}>
            <Link to="/" className={styles.backLink}>
              <Icon icon="lucide:arrow-left" />
            {t('backToHome')}
            </Link>
          <h1 className={styles.title}>{t('submitResourceTitle')}</h1>
          </div>

          <p className={styles.subtitle}>
          {t('submissionSubtitle')}
          </p>
        </header>

        {error && (
          <div className={styles.errorBanner}>
            <Icon icon="lucide:alert-triangle" />
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.formGroup}>
            <label htmlFor="title">{t('resourceTitleLabel')}</label>
            <input
              id="title"
              name="title"
              type="text"
              value={formData.title}
              onChange={handleChange}
                          placeholder={t('titlePlaceholder')}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="type">{t('resourceTypeLabel')}</label>
            <select id="type" name="type" value={formData.type} onChange={handleChange} required>
                          <option value="Guide">{t('optionGuide')}</option>
                          <option value="Template">{t('optionTemplate')}</option>
                          <option value="Policy">{t('optionPolicy')}</option>
                          <option value="Contact">{t('optionContact')}</option>
                          <option value="Other">{t('optionOther')}</option>
            </select>
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="description">{t('descriptionLabel')}</label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleChange}
                          placeholder={t('descriptionPlaceholder')}
              rows={6}
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="languages">{t('languagesLabel')}</label>
            <input
              id="languages"
              name="languages"
              type="text"
              value={formData.languages}
              onChange={handleChange}
              placeholder={t('languagesPlaceholder')}
            />
          </div>

          <div className={styles.formGroup}>
            <label>{t('uploadFilesLabel')}</label>
            <div className={styles.dropZone}>
              <Icon icon="lucide:upload-cloud" className={styles.uploadIcon} />
                          <p>{t('dragDropText')}</p>
                          <p className={styles.dropHint}>{t('dropHintTypes')}</p>
              <input
                type="file"
                multiple
                onChange={handleFileChange}
                className={styles.fileInput}
              />
            </div>
            {formData.files && formData.files.length > 0 && (
              <div className={styles.fileList}>
                {Array.from(formData.files).map((file, idx) => (
                  <div key={idx} className={styles.fileItem}>
                    <Icon icon="lucide:file" />
                    {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
                  </div>
                ))}
              </div>
            )}
          </div>

          <div className={styles.formActions}>
            <button type="submit" className={styles.submitBtn} disabled={loading}>
                          {loading ? t('submitting') : t('submitForReview')}
            </button>
            <Link to="/collections" className={styles.cancelBtn}>
                          {t('cancel')}
            </Link>
          </div>
        </form>

        <div className={styles.guidelines}>
          <h3>{t('submissionGuidelinesTitle')}</h3>
          <ul>
                      <li>{t('guideline1')}</li>
                      <li>{t('guideline2')}</li>
                      <li>{t('guideline3')}</li>
                      <li>{t('guideline4')}</li>
          </ul>
        </div>
      </div>
    </main>
  );
}
// import { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { Icon } from '@iconify/react';
// import styles from './SubmitResource.module.css';

// export default function SubmitResource() {
//   const [formData, setFormData] = useState({
//     title: '',
//     type: 'Guide',
//     description: '',
//     languages: '',
//     files: null,
//   });

//   const [submitted, setSubmitted] = useState(false);
//   const [error, setError] = useState('');

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleFileChange = (e) => {
//     setFormData((prev) => ({ ...prev, files: e.target.files }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!formData.title.trim() || !formData.description.trim()) {
//       setError('Title and description are required.');
//       return;
//     }
//     // Simulate submission
//     setError('');
//     setSubmitted(true);
//   };

//   if (submitted) {
//     return (
//       <main className={styles.main}>
//         <div className={styles.container}>
//           <div className={styles.successCard}>
//             <Icon icon="lucide:check-circle" className={styles.successIcon} />
//             <h2>Resource Submitted!</h2>
//             <p>Thank you! Our team will review your submission shortly. You'll receive an email when it's published or if we need more info.</p>
//             <div className={styles.successActions}>
//               <Link to="/collections" className={styles.successBtn}>
//                 Browse Collections
//               </Link>
//               <Link to="/" className={styles.successBtnOutline}>
//                 Return to Home
//               </Link>
//             </div>
//           </div>
//         </div>
//       </main>
//     );
//   }

//   return (
//     <main className={styles.main}>
//       <div className={styles.container}>
//         {/* Header */}
//         <header className={styles.header}>
//           <div className={styles.headerTop}>
//             <Link to="/" className={styles.backLink}>
//               <Icon icon="lucide:arrow-left" />
//               Back to Home
//             </Link>
//             <h1 className={styles.title}>Submit a Resource</h1>
//           </div>

//           <p className={styles.subtitle}>
//             Share knowledge that helps protect activists and organizations. All submissions are reviewed by our team.
//           </p>
//         </header>

//         {error && (
//           <div className={styles.errorBanner}>
//             <Icon icon="lucide:alert-triangle" />
//             {error}
//           </div>
//         )}

//         <form onSubmit={handleSubmit} className={styles.form}>
//           <div className={styles.formGroup}>
//             <label htmlFor="title">Resource Title *</label>
//             <input
//               id="title"
//               name="title"
//               type="text"
//               value={formData.title}
//               onChange={handleChange}
//               placeholder="e.g. Emergency Digital Security Protocol v2.1"
//               required
//             />
//           </div>

//           <div className={styles.formGroup}>
//             <label htmlFor="type">Resource Type *</label>
//             <select id="type" name="type" value={formData.type} onChange={handleChange} required>
//               <option value="Guide">Guide / How-to</option>
//               <option value="Template">Template / Checklist</option>
//               <option value="Policy">Policy Document</option>
//               <option value="Contact">Contact / Organization</option>
//               <option value="Other">Other</option>
//             </select>
//           </div>

//           <div className={styles.formGroup}>
//             <label htmlFor="description">Description *</label>
//             <textarea
//               id="description"
//               name="description"
//               value={formData.description}
//               onChange={handleChange}
//               placeholder="Describe the resource, who it's for, what situations it addresses, and any key features..."
//               rows={6}
//               required
//             />
//           </div>

//           <div className={styles.formGroup}>
//             <label htmlFor="languages">Languages (comma-separated)</label>
//             <input
//               id="languages"
//               name="languages"
//               type="text"
//               value={formData.languages}
//               onChange={handleChange}
//               placeholder="English, Spanish, French, Arabic..."
//             />
//           </div>

//           <div className={styles.formGroup}>
//             <label>Upload File(s)</label>
//             <div className={styles.dropZone}>
//               <Icon icon="lucide:upload-cloud" className={styles.uploadIcon} />
//               <p>Drag & drop files here or click to browse</p>
//               <p className={styles.dropHint}>PDF, DOCX, ZIP, images (max 50MB total)</p>
//               <input
//                 type="file"
//                 multiple
//                 onChange={handleFileChange}
//                 className={styles.fileInput}
//               />
//             </div>
//             {formData.files && (
//               <div className={styles.fileList}>
//                 {Array.from(formData.files).map((file, idx) => (
//                   <div key={idx} className={styles.fileItem}>
//                     <Icon icon="lucide:file" />
//                     {file.name} ({(file.size / 1024 / 1024).toFixed(2)} MB)
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>

//           <div className={styles.formActions}>
//             <button type="submit" className={styles.submitBtn}>
//               Submit for Review
//             </button>
//             <Link to="/collections" className={styles.cancelBtn}>
//               Cancel
//             </Link>
//           </div>
//         </form>

//         <div className={styles.guidelines}>
//           <h3>Submission Guidelines</h3>
//           <ul>
//             <li>Resources should be relevant to activist safety, digital security, or human rights protection.</li>
//             <li>Files must be original or properly licensed (no copyrighted material without permission).</li>
//             <li>Provide accurate information — misleading content will be rejected.</li>
//             <li>We review all submissions within 5–7 business days.</li>
//           </ul>
//         </div>
//       </div>
//     </main>
//   );
// }
// import { Icon } from '@iconify/react';
// import styles from './SubmitResource.module.css';

// export default function SubmitResource() {
//   return (
//     <main className={styles.main}>
//       <div className={styles.container}>
//         <h1 className={styles.title}>Submit a Resource</h1>
//         <p className={styles.intro}>
//           Share knowledge that can help protect activists and organizations. All submissions are reviewed.
//         </p>

//         <form className={styles.form}>
//           <div className={styles.field}>
//             <label>Title of Resource</label>
//             <input type="text" placeholder="e.g. Emergency Digital Security Protocol v2.1" />
//           </div>

//           <div className={styles.field}>
//             <label>Resource Type</label>
//             <select>
//               <option>Guide / How-to</option>
//               <option>Template / Checklist</option>
//               <option>Policy Document</option>
//               <option>Contact / Organization</option>
//               <option>Other</option>
//             </select>
//           </div>

//           <div className={styles.field}>
//             <label>Description</label>
//             <textarea rows={6} placeholder="Briefly describe the resource, who it helps, and in what situations..."></textarea>
//           </div>

//           <div className={styles.field}>
//             <label>Upload File(s)</label>
//             <div className={styles.dropZone}>
//               <Icon icon="lucide:upload-cloud" className={styles.uploadIcon} />
//               <p>Drag & drop or click to select files</p>
//               <input type="file" multiple hidden />
//             </div>
//           </div>

//           <div className={styles.field}>
//             <label>Language(s)</label>
//             <input type="text" placeholder="English, Spanish, French..." />
//           </div>

//           <div className={styles.actions}>
//             <button type="submit" className={styles.submitBtn}>
//               Submit Resource for Review
//             </button>
//             <button type="button" className={styles.cancelBtn}>Cancel</button>
//           </div>
//         </form>
//       </div>
//     </main>
//   );
// }